module.exports = __webpack_public_path__ + "img/lanscape-3.c0b3eb84.jpg";